// src/views/apps/my-prospects/store/reducer/index.js

// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  total_pages: 1,   // 👈 espejo de total
  params: {},
  selectedUser: null,
  isps: [],
  plans: [],
  cities: [],
  plansClient: [],
  motivosClient: [],
  error: null
};

const myprospects = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_USER':
      return {
        ...state,
        allData: action.data,
        selectedUser: null,
        total: action.totalPages,          // 👈 seguimos llenando total...
        total_pages: action.totalPages,    // 👈 ...y también total_pages
        params: action.params || state.params
      };

    case 'GET_DATA':
      return {
        ...state,
        allData: action.data,
        selectedUser: null,
        total: action.totalPages,
        total_pages: action.totalPages,
        params: action.params || state.params
      };

    case 'GET_DATA_USER':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        total_pages: action.totalPages,
        params: action.params || state.params
      };

    case 'GET_USER':
      return { ...state, selectedUser: action.selectedUser };

    case 'ADD_USER':
      return { ...state };

    case 'DELETE_USER':
      return { ...state };

    case 'INITIATE_INSTANCE':
      return { ...state };

    case 'GET_ALL_DATA_ISP_X':
      return { ...state, isps: action.data };

    case 'GET_ALL_DATA_PLAN':
      return { ...state, plans: action.data };

    case 'GET_ALL_DATA_CITY':
      return { ...state, cities: action.data };

    case 'FETCH_PLANS_SUCCESS':
      return { ...state, plansClient: action.payload };

    case 'FETCH_PLANS_ERROR':
      return { ...state, error: action.payload };

    case 'FETCH_MOTIVOS_SUCCESS':
      return { ...state, motivosClient: action.payload };

    case 'FETCH_MOTIVOS_ERROR':
      return { ...state, error: action.payload };

    default:
      return state; // no es necesario clonar aquí
  }
};

export default myprospects;
